import React, { useState, useEffect } from 'react';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import Pagination from '../Users/Pagination';

const Payments = () => {
  const [payment, setPayment] = useState([]);
  const [searchPayment, setSearchPayment] = useState('');
  // User is currently on this page
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = payment.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(payment.length / recordsPerPage);

  // get all users
  const getUsers = async () => {
    const response = await axios.get('/api/v6/payments');
    setPayment(response.data);
    console.log(response.data);
  };


  useEffect(() => {
    getUsers();
  }, []);

  return (
    <div>
      <div className='mx-auto p-4 lg:container'>
        <div className='bg-white p-4 rounded-lg'>
          <div className='p-4'>
            <p className='text-2xl'>All payments</p>
          </div>
          <hr />
          <div className='flex justify-between p-4 '>
            <p className='text-lg'>Showing {payment.length} entries</p>
            <div>
              <form action=''>
                <div className='items-center'>
                  <label htmlFor=''> 
                    <input
                      type='search'
                      className='ml-2 px-2 py-1 bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full focus:ring-1'
                      required
                      placeholder='Search payment'
                      value={searchPayment}
                      onChange={e => setSearchPayment(e.target.value)}
                    />
                  </label>
                </div>
              </form>
            </div>
          </div>
          <div className='overflow-x-auto border border-slate-300 h-[40em]'>
            {
                currentRecords.length > 0
                  ? (
                    <table className='w-full text-justify table-auto'>
                      <thead>
                        <tr className='border-b border-slate-500'>
                          <th className='py-3 px-6'>No.</th>
                          <th className='py-3 px-6'>Transaction Id</th>
                          <th className='py-3 px-6'>Sort Date</th>
                          <th className='py-3 px-6'>Amount</th>
                          <th className='py-3 px-6'>Created At</th>
                          {/* <th className='py-3 px-6'>Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((payment, index) => (
                          <tr key={payment._id}>
                            <td className='py-2 px-6'>{index + 1}</td>
                            <td className='py-2 px-6'>{payment.transactionId}</td>
                            <td className='py-2 px-6'>{payment.date}</td>
                            <td className='py-2 px-6'>{payment.amount}</td>
                            <td className='py-2 px-6'>{new Date(payment.createdAt).toLocaleString()}</td>
                            {/* <td className='flex items-center py-4 px-6 space-x-2'>
                              <Link to={`/user/eit/${user._id}`} className='bg-teal-500 p-1 text-md text-white mr-1'><FaEdit /></Link>
                              <Link to={`/user/eit/${user._id}`} className='bg-teal-500 p-1 text-md text-white mr-1'>Accept</Link>
                              <button onClick={() => deleteUser(user._id)} className='bg-red-500 p-1 text-md text-white'><MdDelete /></button>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    )
                  : (
                    <div className='bg-[#EEF1FF] h-full grid place-items-center'>
                      <div className='grid place-items-center'>
                        <h2><MdOutlineBlock /></h2>
                        <h4>No Data</h4>
                      </div>
                    </div>
                    )
}

          </div>
          <Pagination
            nPages={nPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Payments;
